/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Attach_OpenInputs */

const cs_chat_attach_open = /** @type {(inputs: Chat_Attach_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přiložit`)
};

const en_chat_attach_open = /** @type {(inputs: Chat_Attach_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attach`)
};

/**
* | output |
* | --- |
* | "Attach" |
*
* @param {Chat_Attach_OpenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_attach_open = /** @type {((inputs?: Chat_Attach_OpenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Attach_OpenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_attach_open(inputs)
	return cs_chat_attach_open(inputs)
});